import { Routes, Route, HashRouter } from 'react-router-dom';
import Shop from './pages/store';
import Contact from './pages/contact/Contact';
import Updates from './pages/updates';
import GameSingle from './pages/Game/GameScreen/GameSingle';
import Blogs from './pages/blogs/Blogs';
import BlogDetails from './pages/blogdetails/BlogDetails';
import ScrollToTopRoute from './components/scrolltotop/ScrollToTopRoute';
import Leaderboard from './pages/leaderboard';

import {
  EthereumClient,
  modalConnectors,
  walletConnectProvider,
} from '@web3modal/ethereum';

import { Web3Modal } from '@web3modal/react';

import { configureChains, createClient, WagmiConfig } from 'wagmi';
import { Toaster } from 'react-hot-toast';
import Teams from './pages/teams';
import SingleTeamPage from './pages/teams/SingleTeamScreen';
import Home from './pages/home';
import Portfolio from './pages/portfolio';
import { TeamProvider } from './contexts/TeamContext';

// Custom Base Sepolia chain definition (not available in wagmi 0.11.5)
const baseSepolia = {
  id: 84532,
  name: 'Base Sepolia',
  network: 'base-sepolia',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://sepolia.base.org'] },
    public: { http: ['https://sepolia.base.org'] },
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://sepolia.basescan.org' },
  },
  testnet: true,
};

function App() {
  //  const [loading,setLoading] = useState(false);

  //  useEffect(()=>{
  //   setLoading(true)
  //   setTimeout(()=>{
  //     setLoading(false)
  //   },8000)
  //  },[])
  //  {
  //   loading ?(
  //     <MoonLoader color={color} loading={loading} css={override} size={150} />
  //   )

  // }

  const chains = [baseSepolia];
  const { provider } = configureChains(chains, [
    walletConnectProvider({ projectId: 'e6e3a0620eb31644a2313cc0c0d14d1f' }),
  ]);
  const wagmiClient = createClient({
    autoConnect: true,
    connectors: modalConnectors({
      projectId: 'e6e3a0620eb31644a2313cc0c0d14d1f',
      version: '2',
      appName: 'web3Modal',
      chains,
    }),
    provider,
  });

  // Web3Modal Ethereum Client
  const ethereumClient = new EthereumClient(wagmiClient, chains);

  return (
    <div className="App">
      <WagmiConfig client={wagmiClient}>
        <Toaster
          position="bottom-center"
          reverseOrder={false}
          toastOptions={{
            style: {
              background: '#0E6D9B',
              color: '#fff',
              fontSize: '1em',
              wordBreak: 'break-all',
            },
          }}
        />
        <TeamProvider>
          <HashRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/game-single" element={<GameSingle />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/updates" element={<Updates />} />
              <Route path="/blog-details" element={<BlogDetails />} />
              <Route path="/leader-board" element={<Leaderboard />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/single-team" element={<SingleTeamPage />} />
            </Routes>
            <ScrollToTopRoute />
          </HashRouter>
        </TeamProvider>
      </WagmiConfig>
      <Web3Modal
        projectId="e6e3a0620eb31644a2313cc0c0d14d1f"
        ethereumClient={ethereumClient}
      />
    </div>
  );
}

export default App;
